import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from 'react-query'
import { Form, Tabs } from 'antd'
import { useTranslation } from 'react-i18next'

import { AppContext } from '../../context/AppContext'

import PageWrap from '../../components/layout/PageWrap'
import FormWrap from '../../components/forms/FormWrap'
import FormBlock from '../../components/forms/FormBlock'
import Loader from '../../components/Loader'
import Error from '../../components/Error'
import SupplierAnalytics from './SupplierAnalytics'

import {
    Information,
    Other,
    cleanBeforeSending,
} from '../../constants/forms/Suppliers'
import { EditSupplier, getSingleSupplier, getSuppliersList } from '../../network/Suppliers'

const { TabPane } = Tabs

const formatData = (data) => ({
    ...data,
    communities: data.communities?.map((c) => c?.id ?? c),
})

const SupplierDetails = ({ history }) => {
    const [form] = Form.useForm()
    const { token } = useContext(AppContext)
    const { t } = useTranslation()
    const [suppliers, setSuppliers] = useState([])

    const [activeTab, setActiveTab] = useState(
        history?.location?.defaultTab || 'information'
    )

    useEffect(() => {
        if (history?.location?.defaultTab) {
            setActiveTab(history.location.defaultTab)
        }
    }, [history?.location?.defaultTab, history?.location?.search])

    useEffect(() => {
        getSuppliersList(token.token).then((data) => {
            setSuppliers(data.list)
        })
    }, [])

    let { supplierId } = useParams()
    const supplierDetails = useQuery(
        [
            'getSingleSupplier',
            {
                supplierId: supplierId,
                token: token.token,
            },
        ],
        getSingleSupplier,
        {
            refetchOnWindowFocus: false,
        }
    )

    return (
        <PageWrap
            goBack
            isLoading={supplierDetails.isLoading}
            title={supplierDetails.data?.name}
        >
            {supplierDetails.isError ? (
                <Error retry={() => supplierDetails.refetch()} />
            ) : supplierDetails.isLoading ? (
                <Loader />
            ) : (
                <Tabs
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    destroyInactiveTabPane
                    className="customerDetailTab"
                    style={{
                        backgroundColor: '#fff',
                        padding: '0px',
                    }}
                >
                    <TabPane tab={t('SUPPLIERS_INFORMATION')} key="information">
                        <FormWrap
                            form={form}
                            title="create_offer"
                            request={EditSupplier}
                            cleanBeforeSending={cleanBeforeSending}
                            checkValidity={(values) => {
                                for (const i in suppliers) {
                                    if (supplierId !== suppliers[i].id) {
                                        if (
                                            suppliers[i].name?.toLowerCase() ===
                                            values.name?.toLowerCase()
                                        ) {
                                            return 'Supplier already exists'
                                        }
                                    }
                                }

                                return false
                            }}
                            id={supplierId}
                            data={formatData(supplierDetails.data)}
                            onSuccess="/suppliers"
                            onCancel="/suppliers"
                            invalidate={[
                                'getSingleSupplier',
                                'getSuppliers',
                            ]}
                        >
                            <div className="SectionHorizontalWrap">
                                <FormBlock
                                    weight={2}
                                    form={form}
                                    formTemplate={Information}
                                    data={formatData(supplierDetails.data)}
                                />
                                <FormBlock
                                    form={form}
                                    formTemplate={Other}
                                    data={formatData(supplierDetails.data)}
                                />
                            </div>
                        </FormWrap>
                    </TabPane>
                    <TabPane tab={t('MENU_ANALYTICS')} key="analytics">
                        <SupplierAnalytics supplierId={supplierId} />
                    </TabPane>
                </Tabs>
            )}
        </PageWrap>
    )
}

export default SupplierDetails
